import { StyleSheet } from 'aphrodite/no-important';
import { IGenericObject } from 'models/base';
import { children, media, OIPResponsiveBackground } from 'util/style-helpers';

export const style: any = (styles: IGenericObject) => {
  const { isNavStatic, isHomePage } = styles;

  return StyleSheet.create({
    background: {
      position: 'fixed',
      display: 'block',
      top: '0',
      left: '0',
      width: '100vw',
      height: '100vh',
      // ...OIPResponsiveBackground({opacity: 'dark', fixed: true}),
      zIndex: -9999,
      transform: 'translateZ(0)',
      willChange: 'transform',
    },
    appContainer: {
      display: 'flex',
      flexDirection: 'column',
      minHeight: '100vh',
      flexGrow: 1,
      ...OIPResponsiveBackground({ opacity: 'dark', fixed: true }),

      [children('main')]: {
        flexGrow: 1,
        paddingTop: isNavStatic ? 0 : '120px !important',

        [media.tablet]: {
          paddingTop: isNavStatic ? 0 : '140px !important',
        },
        [media.desktop]: {
          paddingTop: isNavStatic ? 0 : '140px !important',
        },
      },
    },
  });
};
